export class UpdateClientSettingsItemArray extends Array<UpdateClientSettingsItem> {

    constructor(...items: UpdateClientSettingsItem[]) {
        super(...items);
        Object.setPrototypeOf(this, UpdateClientSettingsItemArray.prototype);
    }


}

export class UpdateClientSettingsItem {
    ID: number;
    MaxDownloadSpeedKBs: number;
    MaxConcurrentDownloads: number;
    Name: string;
    Description: string;
    IsDefault: boolean;
}
